import LocationCityIcon from "@material-ui/icons/LocationCity";
import CityList from "./CityList";

export default {
  list: CityList,
  icon: LocationCityIcon,
};
